import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TermoUsoView from '../views/TermoUsoView.vue'
import PoliticaView from '../views/PoliticaView.vue'
import CidadeView from '../views/CidadeView.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/termos-de-uso',
    name: 'termos-de-uso',
    component: TermoUsoView
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    component: PoliticaView
  },
  {
    path: '/cidades-atendidas',
    name: 'cidades-atendidas',
    component: CidadeView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
